import { QueryClient } from "@tanstack/react-query";

import { STALE_TIME } from "#app/http/ReactQueryProvider";
import {
  fetchQuoteRequestLine,
  QuoteRequestLineDto,
} from "#modules/quoteRequestLines/infra/fetchQuoteRequestLine.api";
import { queryKeys } from "#shared/queryKeys/queryKeys";

export const quoteRequestLineQuery = ({ id }: { id: string | undefined }) => ({
  queryKey: queryKeys.quoteRequestLines.detail(id),
  queryFn: () => fetchQuoteRequestLine({ id }),
  staleTime: STALE_TIME,
  enabled: !!id,
});

export const getQuoteRequestLineQueryData = (
  queryClient: QueryClient,
  id: string,
): QuoteRequestLineDto | undefined => {
  return queryClient.getQueryData<QuoteRequestLineDto>(queryKeys.quoteRequestLines.detail(id));
};

type QuoteRequestLineQueryDataUpdater =
  | QuoteRequestLineDto
  | undefined
  | ((old: QuoteRequestLineDto | undefined) => QuoteRequestLineDto | undefined);

export const setQuoteRequestLineQueryData = (
  queryClient: QueryClient,
  id: string,
  updater: QuoteRequestLineQueryDataUpdater,
): QuoteRequestLineDto | undefined => {
  return queryClient.setQueryData<QuoteRequestLineDto>(
    queryKeys.quoteRequestLines.detail(id),
    updater,
  );
};
